import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '外部项目接口',
    type: 'BDLOGIC_1',
}
